import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const links = [["/about", "footer.about"], ["/privacy", "footer.privacy"], ["/terms", "footer.terms"], ["/contact", "footer.contact"]];
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="container-z grid gap-10 py-14 md:grid-cols-[1.4fr_1fr]">
        <div className="space-y-4">
          <Logo light />
          <p className="max-w-md text-sm leading-relaxed text-white/70">{t("footer.note")}</p>
          <p className="text-sm font-medium text-cyan">Every Student. Every Problem. One Solution.</p>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 gap-3 self-start text-sm">
          {links.map(([to, k]) => (
            <Link key={to} to={to} className="text-white/80 hover:text-cyan" data-testid={`footer-${k.split(".")[1]}-link`}>{t(k)}</Link>
          ))}
          <Link to="/solve" className="text-white/80 hover:text-cyan" data-testid="footer-solve-link">AI Solver</Link>
          <Link to="/docs" className="text-white/80 hover:text-cyan" data-testid="footer-docs-link">ZOHFRY Docs</Link>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="container-z flex flex-col gap-2 py-5 text-xs text-white/60 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} ZOHFRY · zohfry.com · {t("footer.rights")}</span>
          <span>Made for students of India · Bihar first</span>
        </div>
      </div>
    </footer>
  );
};
